<template>
  <i class="scale-110 hover:scale-150 cursor-pointer p-2" :class="props.icon" />
</template>

<script setup>

const props = defineProps({
    icon: String
})

</script>
